import { Check, ChevronRight, FileText } from 'lucide-react';
import { groupBy } from 'lodash';
import { formatDate } from 'utils/helpers';

const Item = ({ consent, onClick }) => {
  const { title, description, procedures = [], status, created_at } = consent?.attributes || {};
  const proceduresByDate = Object.entries(groupBy(procedures, ({ expected_date }) => expected_date || ''));

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full flex-wrap items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-secondary-50"
    >
      {status ? (
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-success-100 bg-success-50 text-success-600">
          <Check size={14} strokeWidth={3} />
        </span>
      ) : (
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-secondary-400">
          <FileText size={16} />
        </span>
      )}

      <span className="min-w-0 flex-1">
        <span className="block text-sm font-bold text-secondary-900 sm:truncate">{title}</span>
        {description && <span className="mt-0.5 block text-xs text-secondary-400 sm:truncate">{description}</span>}
        {procedures.length > 0 && (
          <span className="mt-1.5 flex flex-wrap gap-1.5">
            {proceduresByDate.map(([date, items]) => (
              <span key={date} className="inline-flex max-w-full flex-wrap items-center gap-x-1.5 rounded-md border border-gray-200 bg-secondary-50 px-2 py-0.5 text-[11px]">
                <span className="font-medium text-secondary-600">{items.map(({ label }) => label).join(', ')}</span>
                {date && <span className="whitespace-nowrap text-secondary-400">{formatDate(date, 'medium')}</span>}
              </span>
            ))}
          </span>
        )}
      </span>

      <span className="flex basis-full items-center justify-between gap-3 sm:basis-auto sm:justify-end">
        {status ? (
          <>
            <span className="text-xs text-secondary-400">Signed {formatDate(created_at, 'longDateWithTime')}</span>
            <span className="text-xs font-semibold text-secondary-700">View</span>
          </>
        ) : (
          <span className="rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-amber-700">
            Needs signature
          </span>
        )}

        <ChevronRight size={16} className="shrink-0 text-secondary-300" />
      </span>
    </button>
  );
};

export default Item;
